import React, { Component } from 'react';
import './Side.css';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import { Link, withRouter } from "react-router-dom";
import SideOptions from "./SideOptions";
import { AuthContext } from "../../context/authContext";

const CATEGORY_ICONS = {
  "Roles de Usuario": "admin_panel_settings",
  "Incidencias Manifiestos": "warning_amber",
  "Listas de Precios": "request_quote",
  "Digitalizacion de Documentos": "document_scanner",
  "Recolecciones": "local_shipping",
  "Documentación": "description",
  "EAD": "directions_bus",
  "Ventas": "point_of_sale",
  "Cobranza": "account_balance_wallet",
  "Archivos de clientes": "folder_shared",
  "Catalogos": "dataset",
  "Clientes": "group",
  "Reportes": "analytics",
  "Pago a transportista": "payments",
  "Default": "folder",
};

// Helper function to sort alphabetically by label (for Catalogos)
const sortAlphabetically = (items = []) => {
  if (!items || items.length === 0) return [];
  return [...items]
    .map(item => {
      if (item.children && Array.isArray(item.children)) {
        return {
          ...item,
          children: sortAlphabetically(item.children)
        };
      }
      return item;
    })
    .sort((a, b) => {
      const labelA = (a.label || '').trim();
      const labelB = (b.label || '').trim();
      return labelA.localeCompare(labelB, 'es', { sensitivity: 'base' });
    });
};

// Keep original root order, but sort children inside "Catalogos" alphabetically
const PROCESSED_SIDE_OPTIONS = SideOptions.map(option => {
  const isCatalogos = option.label && option.label.toLowerCase().includes('catalogo');
  if (isCatalogos && option.children && Array.isArray(option.children)) {
    return {
      ...option,
      children: sortAlphabetically(option.children)
    };
  }
  return option;
});

class Side extends Component {
  state = {
    openGroups: {}, // track which accordion groups are expanded
  };

  componentDidMount() {
    this.expandActiveGroup();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.expandActiveGroup();
    }
  }

  expandActiveGroup = () => {
    const currentPath = this.props.location.pathname;
    const newOpenGroups = { ...this.state.openGroups };

    PROCESSED_SIDE_OPTIONS.forEach((option, idx) => {
      if (option.type === 'children' && option.children) {
        const hasActiveChild = option.children.some(child => 
          child.link === currentPath || (child.children && child.children.some(grandChild => grandChild.link === currentPath))
        );
        if (hasActiveChild) {
          newOpenGroups[idx] = true;
        }
      }
    });

    this.setState({ openGroups: newOpenGroups });
  };

  hasAccess(access = []) {
    if (this.context.is_admin) return true;
    if (!access || access.length === 0) return true;
    return this.context.access && this.context.access.some(a => access.includes(a));
  }

  isChildren(option) {
    if (!option.children) return false;
    let access = option.children.map(c => c.access).flat(1).filter(Boolean);
    if (access.length === 0) return true;
    return this.hasAccess(access);
  }

  toggleGroup = (index) => {
    this.setState(prevState => ({
      openGroups: {
        ...prevState.openGroups,
        [index]: !prevState.openGroups[index]
      }
    }));
  };

  renderSubmenu(options, parentKey = '') {
    const currentPath = this.props.location.pathname;
    const { onNavigateMobile } = this.props;

    return (
      <div className="submenu-children">
        {options.map((option, idx) => {
          const key = `${parentKey}-${idx}-${option.link || option.label}`;
          if ((option.type === 'link' && !this.hasAccess(option.access)) || 
              (option.type === 'children' && !this.isChildren(option)) || 
              option.hidden) {
            return null;
          }

          if (option.type === 'children') {
            const isSubOpen = Boolean(this.state.openGroups[key]);
            return (
              <div key={key} style={{ width: '100%' }}>
                <button
                  type="button"
                  className="menu-group-header"
                  style={{ fontSize: '0.78rem', padding: '0.45rem 0.65rem' }}
                  onClick={() => this.toggleGroup(key)}
                >
                  <span className="menu-group-label">{option.label}</span>
                  <Icon className={`menu-group-arrow ${isSubOpen ? 'open' : ''}`}>expand_more</Icon>
                </button>
                {isSubOpen && this.renderSubmenu(option.children, key)}
              </div>
            );
          }

          const isActive = currentPath === option.link;
          return (
            <Link
              key={key}
              to={option.link || '#'}
              className={`menu-nav-link ${isActive ? 'active' : ''}`}
              style={{ fontSize: '0.78rem', padding: '0.45rem 0.65rem' }}
              onClick={() => onNavigateMobile && onNavigateMobile()}
            >
              <span className="menu-group-label">{option.label}</span>
            </Link>
          );
        })}
      </div>
    );
  }

  renderMenu(options) {
    const currentPath = this.props.location.pathname;
    const { isCollapsed, onNavigateMobile } = this.props;

    return (
      <div className="sidebar-menu-list">
        {options.map((option, idx) => {
          const key = `top-${idx}`;
          if ((option.type === 'link' && !this.hasAccess(option.access)) || 
              (option.type === 'children' && !this.isChildren(option)) || 
              option.hidden) {
            return null;
          }

          const iconName = CATEGORY_ICONS[option.label] || CATEGORY_ICONS["Default"];

          if (option.type === 'children') {
            const isOpen = Boolean(this.state.openGroups[idx]);
            const hasActive = option.children?.some(c => c.link === currentPath);

            if (isCollapsed) {
              return (
                <Tooltip key={key} title={option.label} placement="right">
                  <button
                    type="button"
                    className={`menu-group-header collapsed-icon-only ${hasActive ? 'active' : ''}`}
                    onClick={() => {
                      this.props.onToggleCollapse();
                      this.toggleGroup(idx);
                    }}
                  >
                    <Icon className="menu-icon">{iconName}</Icon>
                  </button>
                </Tooltip>
              );
            }

            return (
              <div key={key} className="menu-group-wrapper">
                <button
                  type="button"
                  className={`menu-group-header ${hasActive ? 'active' : ''}`}
                  onClick={() => this.toggleGroup(idx)}
                >
                  <div className="menu-group-left">
                    <Icon className="menu-icon">{iconName}</Icon>
                    <span className="menu-group-label">{option.label}</span>
                  </div>
                  <Icon className={`menu-group-arrow ${isOpen ? 'open' : ''}`}>expand_more</Icon>
                </button>
                {isOpen && this.renderSubmenu(option.children, key)}
              </div>
            );
          }

          const isActive = currentPath === option.link;
          if (isCollapsed) {
            return (
              <Tooltip key={key} title={option.label} placement="right">
                <Link
                  to={option.link || '#'}
                  className={`menu-nav-link collapsed-icon-only ${isActive ? 'active' : ''}`}
                  onClick={() => onNavigateMobile && onNavigateMobile()}
                >
                  <Icon className="menu-icon">{iconName}</Icon>
                </Link>
              </Tooltip>
            );
          }

          return (
            <Link
              key={key}
              to={option.link || '#'}
              className={`menu-nav-link ${isActive ? 'active' : ''}`}
              onClick={() => onNavigateMobile && onNavigateMobile()}
            >
              <Icon className="menu-icon">{iconName}</Icon>
              <span className="menu-group-label">{option.label}</span>
            </Link>
          );
        })}
      </div>
    );
  }

  render() {
    const { isCollapsed, isMobileOpen, onToggleCollapse, onCloseMobile } = this.props;
    const { prop } = this.context;

    return (
      <React.Fragment>
        {/* Mobile Backdrop */}
        <div
          className={`sidebar-overlay ${isMobileOpen ? 'mobile-open' : ''}`}
          onClick={onCloseMobile}
        />

        {/* Sidebar Main */}
        <aside
          className={`modern-sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}
        >
          {/* Header with Logo */}
          <div className="sidebar-header">
            <Link to="/" className="sidebar-brand-link" onClick={onCloseMobile}>
              {prop?.logo_url ? (
                <img alt="logo" src={prop.logo_url} className="sidebar-logo" />
              ) : (
                <div className="sidebar-logo flex items-center justify-center bg-orange-600 text-white font-bold text-sm">
                  SX
                </div>
              )}
              {!isCollapsed && (
                <h1 className="sidebar-title">{prop?.nombre_sistema || 'SOLEXX'}</h1>
              )}
            </Link>
            
            {/* Desktop Collapse Button */}
            <button
              type="button"
              className="sidebar-collapse-btn hidden md:flex"
              onClick={onToggleCollapse}
              title={isCollapsed ? "Expandir menú" : "Colapsar menú"}
            >
              <Icon style={{ fontSize: 20 }}>
                {isCollapsed ? "chevron_right" : "chevron_left"}
              </Icon>
            </button>
          </div>

          {/* Navigation Items */}
          <div className="sidebar-content">
            {this.renderMenu(PROCESSED_SIDE_OPTIONS)}
          </div>
        </aside>
      </React.Fragment>
    );
  }
}

Side.contextType = AuthContext;
export default withRouter(Side);
